import { THEME_KEY } from 'constants/ThemeConstants';
import { LayoutModeEnum } from 'enums/LayoutModeEnum';

export const saveThemeToStorage = (theme: LayoutModeEnum) => {
  localStorage?.setItem(THEME_KEY, theme);
};
